import BootstrapPagination from 'react-ultimate-pagination-bootstrap-4';
import React from 'react';
import PropTypes from 'prop-types';

/** Pagination component. Most commonly used on list pages. */

const Pagination = ({
  alignment,
  totalPages,
  page,
  setPage,
  placement,
}) => {
  if (totalPages > 1) {
    return (
      <div>
        <div className={`contact-list-react-pagination contact-list-react-pagination-${placement}`}>
          <div className={`pagination pagination-${alignment}`}>
            <BootstrapPagination
              currentPage={page}
              totalPages={totalPages}
              hideFirstAndLastPageLinks
              onChange={setPage}
            />
          </div>
        </div>
      </div>
    );
  }

  return null;
};

Pagination.propTypes = {
  /** Where to align the pagination on the page */
  alignment: PropTypes.oneOf(['right', 'left']),

  /** Unique identifier for placement of pagination */
  placement: PropTypes.oneOf(['top', 'bottom']),

  /** Total number of pages */
  totalPages: PropTypes.number,

  /** Current page number, typically passed through from `withPagination` */
  page: PropTypes.number,

  /** Callback to set page number, typically passed through from `withPagination` */
  setPage: PropTypes.func.isRequired
};

Pagination.defaultProps = {
  alignment: 'right',
  placement: 'top',
  page: 1,
  totalPages: 0
};

export default Pagination;
